import { ProductConfiguration } from "@omni/types/utils/productConfiguration";
import { attempt } from "@omni/utils/function.utils";
import { get } from "@omni/utils/object.utils";

export const getProductConfigurationPreview = (
    configuration?: Record<string, unknown>,
    productConfiguration?: ProductConfiguration
) => {
    return attempt(() => {
        const previewValue = get(
            configuration!,
            productConfiguration!.previewPath!
        );
        return previewValue ? `(${previewValue})` : "";
    }, "");
};
